import { Edit as EditIcon } from "@mui/icons-material";
import { Box, CardContent, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNotification } from "../../hooks/NotificationContext";
import { editCurrentUser, updateOrganization } from "../../modules/users";
import FormField from "../elements/FormField";
import Modal from "../elements/Modal";
import CustomIconButton from "../elements/CustomIconButton";

const ProfileDetails = ({ user, fetchUserData }) => {
  const initialData = {
    first_name: user.first_name,
    last_name: user.last_name,
    organization_name: user.organization_name,
    email: user.email,
    phone_number: user.phone_number,
    role: user.role,
   }
  const [formValues, setFormValues] = useState();
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);
  const { addNotification } = useNotification();

  useEffect(() => {
    setFormValues(initialData);
  }, [user]);

const handleEditForm = async (values) => {
  try {
    const userResponse = await editCurrentUser(values);
    localStorage.setItem('user', JSON.stringify(userResponse));
      if (user?.role === "org-admin" && values.organization_name !== user.organization_name) {
        const orgResponse = await updateOrganization({organization_name: values.organization_name})
      localStorage.setItem('organization', JSON.stringify(orgResponse));
    }
    addNotification("success", "Profile updated successfully");
    fetchUserData();
    handleClose();
  } catch (error) {
    addNotification("danger",error?.message || "Error updating your data. Please try again.");
  }
};

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setError(null);
    setFormValues(initialData);
  };

  return (
    <>
      <CustomIconButton
        sx={{
          position: "absolute",
          top: 0,
          right: 0,
          mt: "16px",
        }}
        title='Edit details'
        disableRipple
        onClick={handleClickOpen}
      >
        <EditIcon />
      </CustomIconButton>
      <Modal open={open} modalTitle="Edit Details" handleClose={handleClose}>
        <CardContent sx={{ pt: 0 }}>
          {error && (
            <Typography variant="body1" color="error">
              {error}
            </Typography>
          )}
          <Box sx={{ m: 1 }}>
            <FormField
              onSubmit={handleEditForm}
              buttonLabel="Save"
              form={formValues}
              isEditable={true}
              setFormValues={setFormValues}
            />
          </Box>
        </CardContent>
      </Modal>
    </>
  );
};

export default ProfileDetails;
